import React, { useState } from "react";
import { Typography, Checkbox, FormControlLabel, Box, Switch, Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useConfirmationDialog } from "hooks/useConfirmationDialog";
import { useBackdrop } from "hooks/useBackdrop";
import { useSnackbar } from "hooks/useSnackbar";
import VhostsService from "services/VhostsService";

// Estilos para ajustar el espaciado vertical del tooltip
const useStyles = makeStyles(() => ({
    tooltip: {
        marginBottom: 4, // ajusta según necesidad
    },
    switchRoot: {
        padding: 8,
    },
    switchBase: {
        "&:hover": {
            backgroundColor: "transparent !important",
        },
        "&$switchChecked": {
            color: "#111827",
        },
        "&$switchChecked + $switchTrack": {
            backgroundColor: "#111827",
            opacity: 1,
        },
    },
    switchChecked: {},
    switchTrack: {
        backgroundColor: "#D1D5DB",
        borderRadius: 999,
        opacity: 1,
    },
    switchThumb: {
        backgroundColor: "#FFFFFF",
        border: "1px solid #9CA3AF",
        boxShadow: "none",
    },
}));

export default function DealerToggleSwitch({
    dealerId,
    isActive = false,
    onStatusChange = () => {},
    reloadOnSuccess = true,
    showLabels = true,
}) {
    const classes = useStyles();
    const { openDialog } = useConfirmationDialog();
    const { openBackdrop, closeBackdrop } = useBackdrop();
    const openSnackbar = useSnackbar();

    const handleToggle = (event) => {
        const updatedStatus = event.target.checked ? 1 : 0;
        let manageVhost = true;

        openDialog({
            customDialog: true,
            showActions: true,
            title: (
                <Typography gutterBottom variant="inherit" style={{ fontSize: 16 }}>
                    {updatedStatus
                        ? "Are you sure you want to enable this dealer's store?"
                        : "Are you sure you want to disable this dealer's store?"}
                </Typography>
            ),
            message: (
                <DialogContent
                    updatedStatus={updatedStatus}
                    manageVhost={manageVhost}
                    onUpdate={(value) => (manageVhost = value)}
                />
            ),
            onConfirm: async () => {
                openBackdrop();

                try {
                    await VhostsService.vhostToggle(dealerId, updatedStatus, manageVhost);

                    openSnackbar(
                        "success",
                        updatedStatus === 1
                            ? "Dealer has been marked as active."
                            : "Dealer has been marked as inactive."
                    );

                    onStatusChange(updatedStatus);

                    if (reloadOnSuccess) window.location.reload();
                } catch (error) {
                    console.error("Error updating VHost:", error);
                    openSnackbar("error", "An error occurred while updating the dealer status.");
                } finally {
                    closeBackdrop();
                }
            },
        });
    };

    return (
        <>
            {showLabels && <Typography style={{ marginRight: 8 }}>Inactive</Typography>}

            <Tooltip
                title="Inactive / Active"
                placement="top"
                arrow
                classes={{ tooltip: classes.tooltip }}
            >
                <span style={{ display: "inline-block" }}>
                    <Switch
                        checked={isActive === 1}
                        onChange={handleToggle}
                        color="primary"
                        disableRipple
                        classes={{
                            root: classes.switchRoot,
                            switchBase: classes.switchBase,
                            checked: classes.switchChecked,
                            track: classes.switchTrack,
                            thumb: classes.switchThumb,
                        }}
                    />
                </span>
            </Tooltip>

            {showLabels && <Typography style={{ marginLeft: 8 }}>Active</Typography>}
        </>
    );
}

function DialogContent({ updatedStatus, manageVhost, onUpdate }) {
    const [checked, setChecked] = useState(manageVhost);

    return (
        <>
            <Typography variant="body2" color="primary">
                {updatedStatus
                    ? "The dealer store will be marked as active and accessible through its domain."
                    : "The dealer store will be marked as inactive and will no longer be accessible."}
                {/*updatedStatus
                    ? "The virtual host will be enabled, linking the store domain to the server."
                    : "The virtual host will be disabled, preventing access to the store."*/}
            </Typography>

            <Typography variant="caption" color="textSecondary">
                {updatedStatus
                    ? "Once activated, customers will be able to access the store using its configured domain."
                    : "Deactivating the store does not delete any data and can be reverted at any time."}

                {/*updatedStatus
                    ? "Enabling the store will restore the virtual host, allowing customers to access the site."
                    : "Disabling the store will deactivate the virtual host, making the site inaccessible, but keeping the configuration intact."*/}
            </Typography>

            <Box mt={2}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={checked}
                            onChange={(e) => {
                                setChecked(e.target.checked);
                                onUpdate(e.target.checked);
                            }}
                            color="primary"
                        />
                    }
                    label={updatedStatus ? "Activate dealer store" : "Deactivate dealer store"}
                    //label={updatedStatus ? "Enable Virtual Host" : "Disable Virtual Host"}
                    style={{ color: "#000" }}
                />
            </Box>
        </>
    );
}
